function getZoomImageSource(image) {
  return image.currentSrc || image.src;
}

function clamp(value, min, max) {
  return Math.min(Math.max(value, min), max);
}

function createExternalZoom(image, zoomRatio) {
  const media = image.closest('.product__media');
  if (!media) return null;

  const imageRect = media.getBoundingClientRect();
  const product = image.closest('.product');
  const infoWrapper = product ? product.querySelector('.product__info-wrapper') : null;
  const infoRect = infoWrapper ? infoWrapper.getBoundingClientRect() : null;
  const gap = 16;
  const fallbackLeft = imageRect.right + gap;
  const useInfoColumn = infoWrapper && infoRect && infoRect.width >= 260;
  const paneLeft = useInfoColumn ? 0 : fallbackLeft;
  const availableWidth = useInfoColumn ? infoRect.width : window.innerWidth - fallbackLeft - gap;
  const paneWidth = Math.min(560, availableWidth, Math.max(320, imageRect.width * 0.78));

  if (paneWidth < 260) return null;

  const paneTop = useInfoColumn ? 0 : clamp(imageRect.top, 16, Math.max(16, window.innerHeight - 240));
  const viewportTop = useInfoColumn ? Math.max(16, infoRect.top) : paneTop;
  const availableHeight = window.innerHeight - viewportTop - 16;
  const paneHeight = Math.min(imageRect.height, paneWidth, availableHeight);

  if (paneHeight < 220) return null;

  const lens = document.createElement('div');
  lens.className = 'image-magnify-lens';
  lens.setAttribute('aria-hidden', 'true');
  lens.style.width = `${paneWidth / zoomRatio}px`;
  lens.style.height = `${paneHeight / zoomRatio}px`;

  const pane = document.createElement('div');
  pane.className = 'image-magnify-external';
  if (useInfoColumn) pane.classList.add('image-magnify-external--in-column');
  pane.setAttribute('aria-hidden', 'true');
  pane.style.left = `${paneLeft}px`;
  pane.style.top = `${paneTop}px`;
  pane.style.width = `${paneWidth}px`;
  pane.style.height = `${paneHeight}px`;
  pane.style.backgroundImage = `url('${getZoomImageSource(image)}')`;
  pane.style.backgroundSize = `${imageRect.width * zoomRatio}px ${imageRect.height * zoomRatio}px`;

  media.appendChild(lens);
  if (useInfoColumn) {
    infoWrapper.appendChild(pane);
  } else {
    document.body.appendChild(pane);
  }

  return { lens, pane, imageRect };
}

function moveExternalZoom(zoom, event, zoomRatio) {
  const { lens, pane, imageRect } = zoom;
  const lensWidth = lens.offsetWidth;
  const lensHeight = lens.offsetHeight;
  const rawLeft = event.clientX - imageRect.left - lensWidth / 2;
  const rawTop = event.clientY - imageRect.top - lensHeight / 2;
  const lensLeft = clamp(rawLeft, 0, imageRect.width - lensWidth);
  const lensTop = clamp(rawTop, 0, imageRect.height - lensHeight);

  lens.style.left = `${lensLeft}px`;
  lens.style.top = `${lensTop}px`;
  pane.style.backgroundPosition = `-${lensLeft * zoomRatio}px -${lensTop * zoomRatio}px`;
}

function removeExternalZoom(zoom) {
  zoom?.lens?.remove();
  zoom?.pane?.remove();
}

function enableZoomOnHover(zoomRatio) {
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  document.querySelectorAll('.product__modal-opener--image').forEach((opener) => {
    if (opener.dataset.zoomHoverBound === 'true') return;

    const image = opener.querySelector('.image-magnify-hover');
    if (!image) return;

    opener.dataset.zoomHoverBound = 'true';
    let zoom = null;

    opener.addEventListener('mouseenter', (event) => {
      zoom = createExternalZoom(image, zoomRatio);
      if (!zoom) return;
      opener.classList.add('is-magnifying');
      moveExternalZoom(zoom, event, zoomRatio);
    });

    opener.addEventListener('mousemove', (event) => {
      if (!zoom) return;
      moveExternalZoom(zoom, event, zoomRatio);
    });

    opener.addEventListener('mouseleave', () => {
      removeExternalZoom(zoom);
      zoom = null;
      opener.classList.remove('is-magnifying');
    });
  });
}

enableZoomOnHover(2);
